import users from './users'
import news from './news'
import feedbacks from './feedbacks'
import promocodes from './promocodes'
import partners from './partners'
import mails from './mails'
import infos from './infos'
import members from './members/index'
import agreements from './agreements'
import science_id from "./science_id"

export default {
  namespaced: true,
  modules: {
    users,
    news,
    feedbacks,
    promocodes,
    partners,
    mails,
    infos,
    members,
    agreements,
    science_id,
  }
}
